import { getAuth0AccessToken } from '../../auth/auth0Client';
import { API_BASE_URL } from '../config';
import { AppError, parseErrorResponse } from '../errors';

export async function r2Fetch<T>(
  endpoint: string,
  options: { method?: string; body?: unknown } = {}
): Promise<T> {
  const auth0Token = await getAuth0AccessToken();

  if (!auth0Token) {
    throw new Error('Auth0 authentication required');
  }

  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${auth0Token}`,
  };

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    method: options.method ?? 'POST',
    headers,
    body: JSON.stringify(options.body ?? {}),
  });

  if (!response.ok) {
    const errorPayload = await parseErrorResponse(response);
    console.error('R2 API Error:', {
      status: response.status,
      endpoint,
      errorPayload,
    });
    if (errorPayload) {
      throw new AppError(errorPayload, response.status);
    }
    throw new Error(`R2 request failed with status ${response.status}`);
  }

  return response.json() as Promise<T>;
}
